import axios from "axios";
export const API = axios.create({
  baseURL:  process.env.NODE_ENV  ==  "development"  ?  "http://localhost:8081/"  :   "https://club-genry.ru:8081/", 
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json"
  }
});
